import Vue from 'vue';
import styled from 'vue-styled-components';
import AdrielInput from '@/components/Common/AdrielInput.vue';

// Vue twin of the React app's `shared/ui/SearchInput` (TASK-14078): FinderIcon
// that tints on focus, a CircleCloseFill clear button, 36px rounded field.
export const Wrapper = styled.div`
    position: relative;
    display: inline-flex;
    align-items: center;
    width: 320px;

    .search-icon {
        position: absolute;
        left: 10px;
        top: 50%;
        transform: translateY(-50%);
        width: 16px;
        height: 16px;
        color: var(--color-gray-70, #949aa1);
        pointer-events: none;

        /* Drawn at 20px with a 1px stroke; keep the stroke at 1px in this
           16px slot, as the design's 16px instance does. */
        path {
            vector-effect: non-scaling-stroke;
        }
    }

    &:focus-within .search-icon {
        color: var(--color-blue-60, #0e74f5);
    }

    .clear-button {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        justify-content: center;
        width: 16px;
        height: 16px;
        padding: 0;
        border: none;
        background: transparent;
        color: var(--color-gray-70, #949aa1);
        cursor: pointer;

        svg {
            width: 16px;
            height: 16px;
        }

        &:hover {
            color: var(--color-gray-100, #3c464f);
        }
    }
`;

export const SearchInput = styled(Vue.component('search-input', AdrielInput))`
    width: 100%;
    min-width: 0;

    &[type='text'] {
        height: 36px;
        padding: 0 32px 0 30px;
        border: 1px solid var(--color-gray-40, #d9dee3);
        border-radius: 8px;
        background: var(--color-gray-white, #fff);
        color: var(--color-gray-100, #3c464f);
        font-size: 14px;
        line-height: 21px;
        letter-spacing: -0.14px;
        text-overflow: ellipsis;

        &::placeholder {
            color: var(--color-gray-70, #949aa1);
        }

        &:active,
        &:focus {
            border-color: var(--color-blue-50, #2f80ed);
            outline: none;
        }

        &:disabled {
            background: var(--color-gray-5, #f7f8f9);
            color: var(--color-gray-70, #949aa1);
        }
    }
`;
